<template>
  <div
    class="lot"
    :class="getLotClass">
    <span class="align-middle">{{ lot.name }}</span>
    <b-badge
      v-if="lot.kitVersion"
      pill
      :variant="'success'"
      class="badge-outlined ml-1">
      {{ lot.kitVersion.version }}
    </b-badge>
    <b-badge
      v-if="lot.kitVersion"
      pill
      :variant="statusBadge"
      class="badge-outlined ml-1">
      {{ lot.kitVersion.status }}
    </b-badge>
  </div>
</template>

<script>
export default {
  props: {
    lot: {
      type: Object,
      default: undefined
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      statuses: {
        VALIDATED: { badge: 'success' },
        NOT_VALIDATED: { badge: 'info' },
        PERF: { badge: 'danger' },
        default: { badge: 'secondary' }
      }
    };
  },
  computed: {
    getLotClass() {
      const date = new Date();
      date.setHours(0,0,0,0);

      return {
        'lot-expired': this.lot.expirationDate < date,
        'focused': this.selected,
        'text-strike-through': !this.lot.active
      };
    },
    statusBadge() {
      const status = this.statuses[this.lot.kitVersion?.status];

      if (!status) {
        return this.statuses.default.badge;
      }

      return status.badge;
    }
  }
};
</script>